/*
 * Copyright (c) 2026 Ipivot Corporation.
 * All rights reserved.
 * This software is the confidential and proprietary information of
 *   Ipivot Corporation ("Confidential Information").
 */

/*
 * Map markers with missing or out of range coordinates project to NaN, which
 * makes the SVG transform invalid and drops the marker at the origin of the
 * map (visually up around Alaska).  Everything plotted on a map must be run
 * through here first so those points are skipped instead of plotted.
 */

export type LatLon = { lat: number, lon: number };

export function validLatLon(lat: any, lon: any): LatLon | null {
    const nLat = Number(lat);
    const nLon = Number(lon);
    if (!Number.isFinite(nLat) || !Number.isFinite(nLon)) {
        return null;
    }
    if (nLat < -90 || nLat > 90 || nLon < -180 || nLon > 180) {
        return null;
    }
    // 0,0 is the null island geo lookups land on when they fail
    if (nLat === 0 && nLon === 0) {
        return null;
    }
    return { lat: nLat, lon: nLon };
}

// Keeps only the annotations that can actually be plotted
export function plottableAnnos<T extends { lat?: any, lon?: any }>(annos: T[] | null | undefined): T[] {
    if (!annos) {
        return [];
    }
    return annos.filter((a) => a && validLatLon(a.lat, a.lon) !== null);
}
